/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { KTCard } from '../../../../../../../../_metronic/helpers'
import { FormHeaderDeliveryClothes } from './Forms/FormHeaderDeliveryClothes'
import { TableDeliveryClothesWrapper } from './Tables/TableDeliveryClothes'
import { Button, ButtonWrapper } from '../../../../../../components/UI/Button'

const DeliveryClothes: FC = () => {

    const handleSave = (event: any) => {
        console.log(event)
    }

    return (
        <KTCard shadow className='m-5'>
            <FormHeaderDeliveryClothes />
            <TableDeliveryClothesWrapper />
            <ButtonWrapper className={'sdx-white-bg'}>
                <Button
                    label='Aprobar y Guardar'
                    onClick={() => handleSave}
                    loading={false}
                    disabled={false}
                />
            </ButtonWrapper>
        </KTCard>
    )
}

export { DeliveryClothes }
